var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.94 31.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0a0a0a",
    d: "M16,0a15.9,15.9,0,1,0,16,15.9A15.94,15.94,0,0,0,16,0m0,30.2A14.3,14.3,0,1,1,30.35,15.9,14.33,14.33,0,0,1,16,30.2m5.47-18.27-1.23-1.2a.57.57,0,0,0-.8,0L16,14.15l-3.44-3.42a.57.57,0,0,0-.8,0l-1.22,1.2a.55.55,0,0,0,0,.8L14,16.15l-3.44,3.44a.55.55,0,0,0,0,.8l1.22,1.2a.57.57,0,0,0,.8,0L16,18.17l3.44,3.42a.57.57,0,0,0,.8,0l1.23-1.2a.57.57,0,0,0,0-.8L18,16.15l3.45-3.42a.57.57,0,0,0,0-.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseInCircle);
export default __webpack_public_path__ + "static/media/close-in-circle.249737b5d48ce75ad0c3d52c1ec77f26.svg";
export { ForwardRef as ReactComponent };